import { getNodePublicAssetPath } from "common/utils/publicAssetPaths";
import type * as fsModule from "fs";
import type * as pathModule from "path";
import { PROP_LIBRARY_BINARY_PUBLIC_PATH } from "./propLibraryPaths";

function getCandidatePaths(path: typeof pathModule): string[] {
  const candidateRelativePaths = new Set<string>([
    getNodePublicAssetPath(PROP_LIBRARY_BINARY_PUBLIC_PATH),
    // Next.js server output resolves static assets from apps/web/public/ via the
    // app root, so runtime code under .next should look for public/ directly.
    getNodePublicAssetPath(PROP_LIBRARY_BINARY_PUBLIC_PATH, __dirname),
  ]);

  return Array.from(candidateRelativePaths, (candidateRelativePath) => path.join(process.cwd(), candidateRelativePath));
}

export function loadPropLibraryBinaryNode(): Uint8Array {
  const getBuiltinModule = process.getBuiltinModule as (<T>(id: string) => T) | undefined;
  if (!getBuiltinModule) {
    throw new Error("process.getBuiltinModule is unavailable for prop library binary loading");
  }

  const fs = getBuiltinModule<typeof fsModule>("fs");
  const path = getBuiltinModule<typeof pathModule>("path");
  const candidatePaths = getCandidatePaths(path);

  for (const candidatePath of candidatePaths) {
    if (fs.existsSync(candidatePath)) {
      return new Uint8Array(fs.readFileSync(candidatePath));
    }
  }

  throw new Error(`Unable to locate prop library binary. Checked: ${candidatePaths.join(", ")}`);
}
